import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-csm-customer-access/src/csmGlobalCustomerAccessSettingsResource.tsx';
import { jsmGlobalCustomerAccessSettingsResource } from '@jira/router-resources__admin-pages-jsm-customer-access/src/jsmGlobalCustomerAccessSettingsResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceCustomerAccessRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceCustomerAccessRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { helpCenterSettingsCustomerAccessAppPageEntryPoint } from './ui/customer-access/index.tsx';

export const csmExperienceCustomerAccessRouteEntry: Route = createEntry(
	csmExperienceCustomerAccessRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-customer-access',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? helpCenterSettingsCustomerAccessAppPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			jsmGlobalCustomerAccessSettingsResource,
			resourceWithCondition(
				() => fg('csm_customer_access_jsm_separation'),
				csmGlobalCustomerAccessSettingsResource,
			),
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
